// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { ellipseMiddleText } from '@node-space/utils'
import { ContactCase } from 'types/contacts'

export type DepositSidePanelBodyProps = {
  contactCase: ContactCase
}

export const DepositSidePanelBody = ({ contactCase }: DepositSidePanelBodyProps) => {
  const { t } = useTranslation()

  return (
    <Box flexCol gapY={12}>
      <DataListItem
        id="payment-in-amount-received"
        testId="payment-in-amount-received"
        title={t('transactions.sideBar.paymentInAmountReceived')}
        body={`${contactCase?.amount} ${contactCase?.currencyCode}`}
      />
      {contactCase?.hash && (
        <DataListItem
          id="hash"
          testId="hash"
          title={t('transactions.sideBar.hash')}
          body={ellipseMiddleText(contactCase?.hash, 20, 10)}
          copyText={contactCase?.hash}
        />
      )}
      {contactCase?.externalId && (
        <DataListItem
          id="externalId"
          testId="externalId"
          title={t('transactions.sideBar.externalId')}
          body={ellipseMiddleText(contactCase?.externalId, 20, 10)}
          copyText={contactCase?.externalId}
        />
      )}
    </Box>
  )
}
